export enum AnswerState {
	Incorrect = 'Incorrect',
	Correct = 'Correct',
	NotTested = 'NotTested',
}
